module.exports = __webpack_public_path__ + "img/media_tem_2.43e9b241.png";